import {Component, ViewEncapsulation, OnInit} from '@angular/core';
import { APPCONFIG } from "../../../config";

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageHeaderComponent implements OnInit{
  AppConfig: any;

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/page-header/page-header.component.ts